import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps"
import * as React from 'react';
import { compose, withProps } from "recompose";
import Marker from 'react-google-maps/lib/components/Marker';
import googleMaps from '../api/googleMaps';
import DirectionsRenderer from 'react-google-maps/lib/components/DirectionsRenderer';
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';


import StandaloneSearchBox from 'react-google-maps/lib/components/places/StandaloneSearchBox';
import MoneyLabel from './MoneyLabel';
import NumberFormat from 'react-number-format';
import DirectionsResult = google.maps.DirectionsResult;
import PlaceResult = google.maps.places.PlaceResult;
import DirectionsLeg = google.maps.DirectionsLeg;
import DirectionsRoute = google.maps.DirectionsRoute;
import LatLngBounds = google.maps.LatLngBounds;
import { ConfigData } from "../config";
import { getApi } from '../api/ApiProvider';
import { BranchSelector, BranchData } from './BranchSelector'


import { AddLocation } from "@material-ui/icons";
// import AsyncTable from "./AsyncTable";

import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search'
import { Link } from "react-router-dom";
import { Client, Driver, Race } from "src/api/model";
import { RaceActions } from "src/store/race/race-actions";
import { SortDirection } from "@material-ui/core/TableCell";
import { ColumnDefinition } from "./AsyncTable";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ClearAll from "@material-ui/icons/ClearAll";
import LocationSeraching from "@material-ui/icons/LocationSearching";
import { format } from "date-fns";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { TableRacesComponent } from "./TableRacesComponent";



export class Dot {
    lat: number;
    lng: number;

    constructor(latitude: number, longitude: number) {
        this.lat = latitude;
        this.lng = longitude;
    }

}

const StepIndicator = ({ step }: { step: number }) => (
    <Typography
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: '#1976d2',
            color: 'white',
            fontSize: '14px',
            fontWeight: 'bold',
            marginRight: '8px',
            marginTop: '2px'
        }}
    >
        {step}
    </Typography>
);

interface VisitsDetail {
    id?: number;
    client: Client | undefined;
    location: Dot;
    visitDateTime: string | undefined;
    observations?: string;
    order?: number;
    street1?: string;
    type: string;
    amount: number;
    nroComprobante?: number;
    tipoComprobante?: string;
}

export interface RouteData {

    origin?: Dot;
    originStreet?: string;
    destiny?: Dot;
    destinyStreet?: string;

    distance?: number;
    price?: number;
    duration?: string;
    fullData?: DirectionsResult;
    route?: DirectionsRoute;
    leg?: DirectionsLeg;
    searchBounds?: LatLngBounds;

    // Client document
    clientDocument?: string;
    clientLocations?: LocationData[];
    selectedClientLocationId?: string;
    selectedClientLocation?: any;

    // Branch data used as origin 
    selectedBranch?: BranchData;
    branchList?: BranchData[];
    races?: Race[]
    clients?: any[]
    selectedDriver?: any;
    drivers?: Driver[];
    selectedType?: string;
    selectedVehicle?: any;
    vehicleId?: number;

    visitsDetail?: any[];
    selectedClient?: Client | undefined;
    selectedLoc?: any;
    items?: any[];
    observation?: string;
}

export interface RouteSelectorProps {
    data?: RouteData;
    config: ConfigData;
    onNewData: (data: RouteData) => void;
    sendData: (data: any) => void;
    notification?: any;
}

type MarkerType = 'origin' | 'destiny';

interface RouteSelectorState {

    data: RouteData;
    line?: string;
    center: Dot;

    // new design clien data
    filter: string,
    filterLoc: string,
    filterDir: string,
    filterVehicle: string,
    pageNum: number,
    pageSize: number,
    locations?: any[];
    totalItems: number;
    isDialogOpenLoc: boolean;
    isDialogOpenReparto: boolean;
    isDialogOpen: boolean;
    isDialogHojaOpen: boolean;
    isDialogOpenVehicle: boolean;
    openSearch: boolean;
    actions: RaceActions;
    selectedValue: string,

    table: {
        data: any;
        sortBy: string;
        sortDirection: SortDirection;
        columnData: ColumnDefinition[];
    };

    confirmarOrdenFlag: boolean;
    visitsDetail: any[];
    setPrice: number;
    limit: number;

    pageNumRace: number;
    pageSizeRace: number;
    totalItemsRace: number;

    dataRace: any;
    filterRace: string;
    dateFromRace: string;
    dateToRace: string;
    type: string;
    driverId: number;
    branchId: number;
    branchDestinyId: number;
    selectedState: string;

    isSelectedDriver?: boolean;
}

interface MapProps {

    zoom: number;
    center: Dot;
    origin?: Dot;
    destiny?: any;
    directions: any;

    handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

    handleDragEnd(whichOne: string, index?: number, type?: string): (e: google.maps.MouseEvent) => void;

}

export interface LocationData {
    id: number;
    lat: number;
    lng: number;

    street1: string;
    client: {
        user: { name: string, email: string }
        phone: string;

    };

}

const RouteMap: React.SFC<MapProps> = (props: MapProps) => {
    const { center, zoom, destiny, handleDragEnd, directions } =
        props;
    return (
        <GoogleMap defaultZoom={zoom} center={center} >
            {/* {
                origin &&
                <Marker draggable
                    onDragEnd={handleDragEnd('origin')}
                    position={origin}
                    label={{ text: "O", color: "white" }}
                />
            } */}
            {destiny &&
                destiny.length > 0 &&
                destiny.map((item: VisitsDetail, index: number) => (
                    // console.log('Queserenderizacomomarker',item),
                    // item.order !== 1 && (
                    <Marker
                        draggable
                        onDragEnd={handleDragEnd("destiny", index, item.order && item.order === 1 ? 'O' : 'R')}
                        position={item.location}
                        label={{ text: item.order && item.order === 1 ? 'O' : 'R' + item.order, color: "white" }}
                        key={index}
                    />
                    // )
                ))}

            {directions && (
                <DirectionsRenderer
                    directions={directions}
                    defaultOptions={{ suppressMarkers: true }}
                />
            )}
        </GoogleMap>
    );
};

const EnhancedMap = compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(RouteMap);

const options = [
    { value: 'REMISION', label: 'Remisiones/Reparto' },
    { value: 'OTHER', label: 'Otro' },
];

const tipoComprobante = [
    { value: "FAC", label: "FAC" },
    { value: "RET", label: " RET" },
    { value: "NCR", label: " NCR" },
    { value: "REC", label: " REC" },
    { value: "AUT", label: " AUT" },
    { value: "FAE", label: " FAE" },
    { value: "CV", label: "CV" },
    { value: "ADEL", label: "ADEL" },
    { value: "EXT", label: "EXT" }
];

class RouteSelector extends React.Component<RouteSelectorProps, RouteSelectorState> {

    refOrigin: StandaloneSearchBox;
    refDestiny: StandaloneSearchBox;

    constructor(props: RouteSelectorProps) {
        super(props);
        this.state = {
            data: {
                originStreet: props.config.races.predefinedFrom ? 'Origen' : '',
                destinyStreet: '',
                clientDocument: '',
                clientLocations: [],
                clients: [],
                selectedDriver: null,
                drivers: [],
                selectedType: '',
                items: [
                    { id: 'item-1', content: 'Item 1' },
                    { id: 'item-2', content: 'Item 2' },
                    { id: 'item-3', content: 'Item 3' },
                ],
                ...props.data,
            },
            center: props.config.maps.startingLocation,

            filter: '',
            filterLoc: '',
            filterDir: '',
            filterVehicle: '',
            pageNum: 0,
            pageSize: 3,
            totalItems: 0,
            locations: [],
            isDialogOpenLoc: false,
            isDialogOpenReparto: false,
            isDialogOpen: false,
            isDialogHojaOpen: false,
            isDialogOpenVehicle: false,
            openSearch: false,
            actions: new RaceActions(),
            selectedValue: 'REMISION',
            table: {
                data: [],
                sortBy: "name",
                sortDirection: "asc",
                columnData: [
                    {
                        path: "client.user.name",
                        label: "Cliente",
                        numeric: false,
                    },
                    {
                        path: "visitDateTime",
                        label: "Fecha",
                        numeric: false,
                    },
                    {
                        path: "type",
                        label: "Tipo de reparto",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order !== 1 &&
                                <Select value={data.type ? data.type : 'REMISION'} onChange={(event) => this.handleSelectChangeOnRow(event, data)}>
                                    {options.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            );
                        },
                    },
                    {
                        path: "tipoDocumento",
                        label: "Tipo de documento",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order !== 1 &&
                                <Select value={data.type ? data.type : 'FAC'} onChange={(event) => this.handleSelectChangeComprobanteOnRow(event, data)}>
                                    {tipoComprobante.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            );
                        },
                    },
                    {
                        path: "nroDocumento",
                        label: "Numero de documento (opcional)",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order !== 1 &&
                                <TextField
                                    label="Nro documento (opcional)"
                                    type="number"
                                    onChange={(e) => this.setNroComprobante(e, data)}
                                    value={data.nroComprobante || ''}
                                    style={{
                                        width: '90%'
                                    }}
                                    margin="normal"
                                />
                            );
                        },
                    },
                    {
                        path: "amount",
                        label: "Fijar precio (opcional)",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order !== 1 &&
                                <TextField
                                    label="Fijar precio (opcional)"
                                    type="number"
                                    inputProps={{ step: "100" }}
                                    onChange={(e) => this.setPrice(e, data)}
                                    value={data.amount || ''}
                                    style={{
                                        width: '90%'
                                    }}
                                    margin="normal"
                                />
                            );
                        },
                    },
                    {
                        path: "observations",
                        label: "Observaciones",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (
                                <TextField
                                    id="observations"
                                    placeholder="Observaciones"
                                    multiline
                                    rows={3}
                                    value={data.observations}
                                    onChange={(event) =>
                                        this.handleObservationsChange(event, data)
                                    }
                                    style={{
                                        width: "90%",
                                    }}
                                    margin="normal"
                                />
                            );
                        },
                    },
                    {
                        path: "order",
                        label: "Orden",
                        numeric: false,
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (
                                <TextField
                                    id="order"
                                    placeholder="Orden"
                                    type="text"
                                    value={data.order}
                                    onChange={(event) => this.handleOrderChange(event, data)}
                                    style={{
                                        width: "40%",
                                    }}
                                    margin="normal"
                                />
                            );
                        },
                    },
                    {
                        path: "",
                        numeric: true,
                        label: "Acciones",
                        draw: (cd: ColumnDefinition, data: VisitsDetail) => {
                            return (data.order && data.order > 1 &&
                                <div>
                                    <IconButton
                                        aria-label="Visitados"
                                        title="Visitados"
                                        onClick={() =>
                                            data.client && this.handleClickRemove(data && data.id ? data.id : 0)
                                        }
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            );
                        },
                    },
                ],
            },
            confirmarOrdenFlag: false,
            visitsDetail: [],
            setPrice: 0,
            limit: 200,
            pageNumRace: 0,
            pageSizeRace: 3,
            totalItemsRace: 0,
            dataRace: {},
            filterRace: '',
            dateFromRace: '',
            dateToRace: '',
            type: '',
            driverId: 0,
            branchId: 0,
            branchDestinyId: 0,
            selectedState: '',
        };

        this.onOriginMounted = this.onOriginMounted.bind(this);
        this.onDestinyMounted = this.onDestinyMounted.bind(this);

        this.handleOnClick = this.handleOnClick.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);
        this.fireNewDataEvent = this.fireNewDataEvent.bind(this);

        this.requestNewDirections = this.requestNewDirections.bind(this);
        this.getRouteDescription = this.getRouteDescription.bind(this);
        this.handleKeyPressInDocument = this.handleKeyPressInDocument.bind(this);
        this.onChangeClientLocationSelect = this.onChangeClientLocationSelect.bind(this);
        this.onChangeBranchSelector = this.onChangeBranchSelector.bind(this);


        this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize, this.state.filterLoc, this.state.filterDir);
        this.obtenerDrivers();
        this.getRaces(0, 3, undefined, undefined, undefined, true, 'ASSIGNED', true);
        this.calculateWaypoints = this.calculateWaypoints.bind(this);
        this.reordenateOrder = this.reordenateOrder.bind(this);
        this.cleanOrder = this.cleanOrder.bind(this);
        this.reorganizateOrder = this.reorganizateOrder.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    obtenerDrivers() {
        getApi().driver().listActiveByAdmin().then((data: Driver[]) => {
            this.setState({
                data: {
                    ...this.state.data,
                    drivers: data
                }
            });

            this.setState(
                {
                    data: {
                        ...this.state.data,
                        visitsDetail: [
                            {
                                client: {
                                    id: "",
                                    user: {
                                        id: 0,
                                        name: "",
                                        email: "",
                                        state: "ACTIVE",
                                    },
                                    document: "01",
                                    phone: "",
                                    observation: "",
                                },
                                location: this.props.data && this.props.data.origin ? this.props.data.origin : new Dot(0, 0),
                                visitDateTime: new Date().toISOString(),
                                observation: 'Origen de recorrido',
                                order: 1,
                                street1: '',
                                type: this.state.data.selectedType ? this.state.data.selectedType : 'OTHER',
                                driver: this.state.data.selectedDriver ? this.state.data.selectedDriver.id : 0,
                                clientName: this.state.data.selectedClientLocation ? this.state.data.selectedClientLocation.client.user.name : '',
                                clientDocument: this.state.data.selectedClientLocation ? this.state.data.selectedClientLocation.client.document : '',
                                origin: {
                                    street1: this.state.data.originStreet ? this.state.data.originStreet : '',
                                    lat: this.state.data.origin ? this.state.data.origin.lat : 0,
                                    lng: this.state.data.origin ? this.state.data.origin.lng : 0,
                                },
                                destiny: {
                                    street1: this.state.data.destinyStreet ? this.state.data.destinyStreet : '',
                                    lat: this.state.data.destiny ? this.state.data.destiny.lat : 0,
                                    lng: this.state.data.destiny ? this.state.data.destiny.lng : 0,
                                },
                                dueDate: new Date().getTime() + 1000 * 60 * 60 * 24,

                            },
                            ...(this.state.data.visitsDetail || []),
                        ],
                    },
                }
            );

            // this.setState({ schema: newSchema });

        }).catch((error) => {
            console.log(error);
        });
    }
    obtenerUbicaciones(pageNum: number, pageSize: number, filter: string, filterDir: string) {
        getApi().client().locations(pageNum, pageSize, filter, filterDir).then((data: any) => {
            this.setState({
                data: {
                    ...this.state.data,
                },
                locations: data.page,
                totalItems: data.totalElements
            });
        }).catch((error) => {
            console.log(error);
        });
    }

    handleOnClick(args: google.maps.MouseEvent | google.maps.IconMouseEvent) {
        if (!this.state.data.origin) {
            this.setState({
                ...this.state,
                data: {
                    ...this.state.data,
                    origin: new Dot(args.latLng.lat(), args.latLng.lng())
                }
            });
            this.fireNewDataEvent(true);
            return;
        }

        if (!this.state.data.destiny) {
            this.setState({
                ...this.state,
                data: {
                    ...this.state.data,
                    destiny: new Dot(args.latLng.lat(), args.latLng.lng())
                }
            });
            this.fireNewDataEvent(true);
            return;
        }

    }

    async requestNewDirections(forceRename: boolean) {
        if (this.state.data.origin && this.state.data.destiny) {
            try {
                const data: DirectionsResult = await googleMaps.getDirections(this.state.data.origin,
                    this.state.data.destiny, this.props.config.maps.region);
                this.handleDirectionsData(data, forceRename);
            } catch (err) {
                console.log(err);
                this.setState({
                    data: {
                        ...this.state.data,
                        distance: undefined,
                        duration: undefined,
                        fullData: undefined,
                        price: undefined
                    }
                });
            }
        }
    }

    handleDirectionsData(data: DirectionsResult, forceNewPosition = true) {

        const route = data &&
            data.routes &&
            data.routes[0];

        const leg = route &&
            route.legs &&
            route.legs[0] &&
            route.legs[0];

        if (!leg) {
            return;
        }

        this.setState({
            data: {
                ...this.state.data,
                originStreet: forceNewPosition ? leg.start_address : this.state.data.originStreet || leg.start_address,
                destinyStreet: forceNewPosition ? leg.end_address : this.state.data.destinyStreet || leg.end_address,
                fullData: data,
                leg: leg,
                route: route,
                distance: leg.distance.value,
                duration: leg.duration.text,
                price: leg.distance.value / 1000 * this.state.setPrice !== 0 ? this.state.setPrice : this.props.config.races.pricePerKm
            }
        });
    }

    getRouteDescription() {
        const data = this.state.data;
        if (!data.fullData) {
            return (<Typography>Seleccione dos puntos para iniciar el calculo de ruta</Typography>)
        }

        return (
            <Typography>
                El viaje es de: <NumberFormat value={(Math.round(data.distance || 0))}
                    suffix={'Km.'}
                    displayType={'text'}
                    decimalScale={4} /> , y
                costará aproximadamente <MoneyLabel amount={data.price} />.
            </Typography>
        )
    }


    handleDragEnd(marker: MarkerType, index?: number, type?: string) {

        return async (e: google.maps.MouseEvent) => {
            if (this.state.data.visitsDetail && this.state.data.visitsDetail.length > 0 && type === 'O') {
                const newVisitDetail = this.state.data.visitsDetail;
                newVisitDetail[0].location = new Dot(e.latLng.lat(), e.latLng.lng());
                this.setState({
                    data: {
                        ...this.state.data,
                        [type === 'O' ? 'origin' : marker]: new Dot(e.latLng.lat(), e.latLng.lng()),
                        visitsDetail: newVisitDetail,
                    },
                });

                this.fireNewDataEvent(true);
                this.calculateWaypoints();
            } else {
                if (index !== undefined && this.state.data.visitsDetail) {
                    const data: DirectionsResult = await googleMaps.getDirections(this.state.data.visitsDetail[0].location,
                        new Dot(e.latLng.lat(), e.latLng.lng()), this.props.config.maps.region);
                    this.setState((prevState) => {
                        const visitsDetail = prevState.data.visitsDetail
                            ? [...prevState.data.visitsDetail]
                            : [];
                        visitsDetail[index].location = new Dot(
                            e.latLng.lat(),
                            e.latLng.lng()
                        );
                        visitsDetail[index].destiny = {
                            lat: e.latLng.lat(),
                            lng: e.latLng.lng(),
                            street1: data.routes[0].legs[0].end_address,
                        };

                        return {
                            data: {
                                ...prevState.data,
                                visitsDetail,
                            },
                        };
                    });
                }
                this.fireNewDataEvent(true);
                this.calculateWaypoints()
            }
        }
    }

    fireNewDataEvent(forceRename: boolean) {
        if (this.state.data.origin || this.state.data.destiny) {
            this.requestNewDirections(forceRename).then(() => {
                this.props.onNewData(this.state.data);
            });
        }
    }

    setNewPlace(ref: StandaloneSearchBox, type: MarkerType) {

        const places: PlaceResult[] = ref.getPlaces();
        const bounds = new google.maps.LatLngBounds();

        places.forEach((place: PlaceResult) => {
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport)
            } else {
                bounds.extend(place.geometry.location)
            }
        });

        const nextMarkers = places.map((place: PlaceResult) => ({
            position: place.geometry.location
        }));
        const nextCenter = nextMarkers && nextMarkers[0] && nextMarkers[0].position || this.state.center;
        const centerDot = new Dot(nextCenter.lat(), nextCenter.lng());

        if (this.state.data.visitsDetail && this.state.data.visitsDetail.length > 0) {
            const newVisitDetail = this.state.data.visitsDetail;
            newVisitDetail[0].location = new Dot(nextCenter.lat(), nextCenter.lng());
            this.setState({
                data: {
                    ...this.state.data,
                    [type]: centerDot,
                    visitsDetail: newVisitDetail,
                },
                center: centerDot
            });
            this.fireNewDataEvent(true);
            this.calculateWaypoints();

        }

    }

    onPlaceSelected(type: MarkerType) {
        return () => {
            this.setNewPlace(type === 'origin' ? this.refOrigin : this.refDestiny, type);
        }
    }

    onOriginMounted(ref: StandaloneSearchBox) {
        this.refOrigin = ref;
        this.getSearchRegionBounds();
        this.getBranchList();
        setTimeout(() => {
            this.onChangeBranchSelector({ target: { value: 0 } } as any);
        }, 1000);
    }

    onDestinyMounted(ref: StandaloneSearchBox) {
        this.refDestiny = ref;
    }


    async getSearchRegionBounds() {
        const bounds: LatLngBounds = await googleMaps.getGeoCodeBounds(this.props.config.maps.region);
        this.setState({
            data: {
                ...this.state.data,
                searchBounds: bounds
            }
        });
    }

    getLocationsByClientDocument(document: string) {
        getApi().admin().clientLocationByDocument(document).then((data) => {
            this.setState({
                data: {
                    ...this.state.data,
                    clientLocations: data
                }
            });

        }).catch(error => {
            this.setState({
                data: {
                    ...this.state.data,
                    clientLocations: undefined,
                    selectedClientLocation: undefined,
                    selectedClientLocationId: undefined
                }
            });
        });
    }




    handleKeyPressInDocument(e: React.KeyboardEvent<any>) {
        if (e.key === 'Enter') {
            if (this.state.data.clientDocument) {
                this.getLocationsByClientDocument(this.state.data.clientDocument);
            }
        }
    }


    onChangeClientLocationSelect(loc: any) {

        this.setState({ filterLoc: "" });
        const client = this.state.data.clients && this.state.data.clients.length > 0
            ? this.state.data.clients.find((c: Client) => c.id === loc.clientId)
            : loc.client;
        if (this.state.data.visitsDetail) {
            const valorRepetido = this.state.data.visitsDetail.some(
                (item: any) => item.id === loc.lat + loc.lng
            );
            if (loc.street1 === "" || loc.street1 === undefined || loc.street1 === null) {
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                    this.props.notification.notification.addWarning("Cliente sin dirección establecida, registre una nueva dirección para el cliente");
                } else {
                    alert("Cliente sin dirección establecida, registre una nueva dirección para el cliente");
                }
                return;
            }
            if (valorRepetido) {
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                    this.props.notification.notification.addWarning("El cliente ya fue seleccionado");
                } else {
                    alert("El cliente ya fue seleccionado");
                }
                return;
            }
        }
        this.setState(
            {
                data: {
                    ...this.state.data,
                    selectedLoc: loc,
                    selectedClient: client,
                    destinyStreet: loc.street1,
                    destiny: new Dot(loc.lat, loc.lng),
                },
                center: new Dot(loc.lat, loc.lng),
            },
            () => {
                if (
                    this.state.data.destiny &&
                    (this.state.data.selectedClient || client)
                ) {
                    if (!this.state.data.selectedClient) {
                        this.setState({
                            data: {
                                ...this.state.data,
                                selectedClient: client,
                            },
                        });
                    }
                    const origin = this.state.data.visitsDetail && this.state.data.visitsDetail.length > 1 ? {
                        street1: this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1].destiny.street1,
                        lat: this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1].destiny.lat,
                        lng: this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1].destiny.lng
                    } : {
                        street1: this.state.data.originStreet ? this.state.data.originStreet : '',
                        lat: this.state.data.origin ? this.state.data.origin.lat : 0,
                        lng: this.state.data.origin ? this.state.data.origin.lng : 0,
                    };
                    const newVisitDetail: any = {
                        id: this.state.data.destiny.lat + this.state.data.destiny.lng,
                        client: this.state.data.selectedClient || client,
                        location: this.state.data.destiny,
                        visitDateTime: new Date().toISOString(),
                        observations: "",
                        order: this.state.data.visitsDetail
                            ? this.state.data.visitsDetail.length + 1
                            : 1,
                        type: this.state.data.selectedType ? this.state.data.selectedType : '',
                        driver: this.state.data.selectedDriver ? this.state.data.selectedDriver.id : 0,
                        clientName: this.state.data.selectedClientLocation ? this.state.data.selectedClientLocation.client.user.name : '',
                        clientDocument: this.state.data.selectedClientLocation ? this.state.data.selectedClientLocation.client.document : '',
                        origin: origin,
                        destiny: {
                            street1: this.state.data.destinyStreet ? this.state.data.destinyStreet : '',
                            lat: this.state.data.destiny ? this.state.data.destiny.lat : 0,
                            lng: this.state.data.destiny ? this.state.data.destiny.lng : 0,
                        },
                        dueDate: new Date().getTime() + 1000 * 60 * 60 * 24,
                    };

                    this.setState(
                        {
                            data: {
                                ...this.state.data,
                                visitsDetail: [
                                    ...(this.state.data.visitsDetail || []),
                                    newVisitDetail,
                                ],
                            },
                        },
                        () => {
                            this.setState({
                                data: {
                                    ...this.state.data,
                                    destiny: undefined,
                                    destinyStreet: "",
                                    selectedClient: undefined,
                                },
                            });
                            this.calculateWaypoints();
                        }
                    );
                }
            }
        );
    }



    getClientLocationByName(id: string): LocationData | undefined {
        const nid = Number(id);
        if (this.state.data.clientLocations) {
            const loc = this.state.data.clientLocations.find(l => l.id === nid);

            return loc ? loc : undefined
        }
        return undefined;
    }



    getBranchList() {
        getApi().branch().listAllBranchesAdmin().then((data) => {
            this.setState({
                data: {
                    ...this.state.data,
                    branchList: data,
                }
            },
                () => {
                    // default first branch selection
                    this.setBranch(0);
                }
            );
        }).catch((error) => {
            console.log(error);
        });
    }

    onChangeBranchSelector(e: React.ChangeEvent<any>) {
        const idx = +e.target.value;
        this.setBranch(idx);
    }


    setBranch(idx: number) {
        const branch = this.state.data.branchList ? this.state.data.branchList[idx] : undefined;
        const origin = this.state.data.origin


        if (this.state.data.visitsDetail && this.state.data.visitsDetail.length > 0 && branch) {
            const newVisitDetail = this.state.data.visitsDetail;
            newVisitDetail[0].location = new Dot(branch.location.lat, branch.location.lng);
            // newVisitDetail[0].origin = {
            //     street1: 'Origen',
            //     lat: branch.location.lat,
            //     lng: branch.location.lng
            // }
            // Se vuelve a cambiar el origen del primer elemento que justamente no sea el origen de la ruta
            if (this.state.data.visitsDetail.length === 2) {
                newVisitDetail[this.state.data.visitsDetail.length - 1].origin = {
                    street1: 'Origen',
                    lat: branch.location.lat,
                    lng: branch.location.lng
                }
            }

            this.setState({
                data: {
                    ...this.state.data,
                    selectedBranch: branch,
                    origin: branch ? new Dot(branch.location.lat, branch.location.lng) : origin,
                    visitsDetail: newVisitDetail,
                }
            }, () => {
                this.fireNewDataEvent(true);
                this.calculateWaypoints();
            });
        }
    }

    /**
     * De momento no se usa este método
     * @param index 
     */
    /*onChangeClientLocationSelect2(index: number) {
        console.log(index);
        if (index < 0) {
            this.setState({
                data: {
                    ...this.state.data,
                    selectedClientLocation: undefined,
                    selectedClientLocationId: undefined
                }
            });
        }


        const location = this.state.data.clientLocations && this.state.data.clientLocations[index];
        if (location && index >= 0) {
            this.setState({
                data: {
                    ...this.state.data,
                    selectedClientLocationId: index.toString(),
                    selectedClientLocation: location,
                    destinyStreet: location.street1,
                    destiny: new Dot(location.lat, location.lng),
                },
                center: new Dot(location.lat, location.lng)
            }, () => this.fireNewDataEvent(true));
        }

    }*/

    handleSelectChangeComprobanteOnRow = (event: React.ChangeEvent<HTMLSelectElement>, data: any) => {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.tipoComprobante = event.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    };
    handleSelectChangeOnRowRace = (event: React.ChangeEvent<HTMLSelectElement>, data: any) => {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.type = event.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    };
    getRaces(pageNum?: number, pageSize?: number, search?: string, from?: string, to?: string, sinCabecera?: boolean, status?: string, conOwner?: boolean) {
        getApi().race().all(pageNum, pageSize, search, from, to, undefined, undefined, status, sinCabecera, conOwner).then((data: any) => {
            console.log(data)
            this.setState({
                dataRace: data.content,
                totalItemsRace: data.totalElements
            });
        })

    }
    setFilter = (filter: string) => {
        this.setState({ filter }, () => {
            this.getRaces(this.state.pageNumRace, this.state.pageSizeRace, this.state.filter, this.state.dateFromRace, this.state.dateToRace, true, 'ASSIGNED', true);
        });
    };

    setPageNum = (pageNumRace: number) => {
        this.setState({ pageNumRace }, () => {
            this.getRaces(this.state.pageNumRace, this.state.pageSizeRace, this.state.filter, this.state.dateFromRace, this.state.dateToRace, true, 'ASSIGNED', true);
        });
    };

    setPageSize = (pageSizeRace: number) => {
        this.setState({ pageSizeRace }, () => {
            this.getRaces(this.state.pageNumRace, this.state.pageSizeRace, this.state.filter, this.state.dateFromRace, this.state.dateToRace, true, 'ASSIGNED', true);
        });
    };

    setDateFromChange = (dateFromRace: string) => {
        this.setState({ dateFromRace }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSizeRace, this.state.filter, this.state.dateFromRace, this.state.dateToRace, true, 'ASSIGNED', true);
        });
    };

    setDateToChange = (dateToRace: string) => {
        this.setState({ dateToRace }, () => {
            this.getRaces(this.state.pageNumRace, this.state.pageSizeRace, this.state.filter, this.state.dateFromRace, this.state.dateToRace, true, 'ASSIGNED', true);
        });
    };
    cleanFiltersRaces = () => {
        this.setState({ filter: '', dateFromRace: '', dateToRace: '' }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSizeRace, this.state.filter, this.state.dateFromRace, this.state.dateToRace, true, 'ASSIGNED', true);
        });
    }
    setDialogRace = (open: boolean, data?: any) => {
        console.log(open, data)
        // this.setState({
        //     // openDialogRace: open,
        //     // dataTemp: data
        // }, () => {
        // });
    };
    setDialogBranch = (open: boolean, data?: any) => {
        console.log(open, data)
    };
    setDialogClient = (open: boolean, data?: any) => {
        console.log(open, data)
    };
    setDialogDriver = (open: boolean, data?: any) => {
        console.log(open, data)
    };
    setDialogChangeState = (open: boolean, data?: any) => {
        console.log(open, data)
    };
    handleTypeChange = (type: string) => {
        this.setState({
            type: type
        }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filterLoc);
        });
    }
    handleStateChange = (event: any) => {
        this.setState({
            selectedState: event.target.value
        }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filterLoc);
        })
    };
    handleDriverChange = (driverId: number) => {
        this.setState({
            driverId: driverId
        }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filterLoc);
        });
    };
    handleBranchChange = (event: any) => {
        console.log(event.target.value)
    }
    handleBranchDestinyChange = (event: any) => {
        console.log(event.target.value)
    }
    handleGeneralSearch = (event: any) => {
        console.log(event.target.value)
    }
    handleSelectChangeOnRow = (event: React.ChangeEvent<HTMLSelectElement>, data: any) => {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.type = event.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    };
    handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        this.setState({
            data: {
                ...this.state.data,
                selectedType: selectedValue,
            },
            selectedValue: event.target.value as string
        });
        // handle the selected value
    };

    async selectDriver(driver: Driver) {
        if (!driver || driver.referenceId == null) {
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning('El conductor no tiene un ID de referencia válido.');
            } else {
                alert('El conductor no tiene un ID de referencia válido.');
            }
            return;
        }
        if(!driver.markAttendance){
            return this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    selectedDriver: driver
                }
            }));
        }
        try {
            const today = new Date();
            const desde = format(today, "YYYY-MM-DDT00:00:00Z");
            const hasta = format(today, "YYYY-MM-DDTHH:mm:ssZ");
            const url = `https://ping.matizsae.com.py/tag/rest/pedidos-movil/marcacion/listar?personaId=${driver.referenceId}&desde=${desde}&hasta=${hasta}`;
            const resp = await fetch(url, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!resp.ok) {
                throw new Error('Error en la respuesta del servidor');
            }
            const data = await resp.json();
            if (Array.isArray(data) && data.length > 0) {
                console.log('Conductor:', driver, this.state.isSelectedDriver);
                this.setState(prevState => ({
                    data: {
                        ...prevState.data,
                        selectedDriver: driver
                    }
                }));
            } else {
                console.warn(this.props.notification);
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                    this.props.notification.notification.addWarning('El conductor no tiene asistencias registradas para el día de hoy.');
                } else {
                    alert('El conductor no tiene asistencias registradas para el día de hoy.');
                }
            }
        } catch (error) {
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning('No se pudo verificar la asistencia del conductor.');
            } else {
                alert('No se pudo verificar la asistencia del conductor.');
            }
            console.error('Error al obtener asistencias:', error);
        }
    }

    selectVehicle(vehicle: any) {
        this.setState(prevState => ({
            data: {
                ...prevState.data,
                selectedVehicle: vehicle,
                vehicleId: vehicle.id
            },
            isDialogOpenVehicle: false,
            filterVehicle: ''
        }));
    }

    validateData(data: any) {
        let missingKeys = '';
        for (let key in data) {
            if (data[key] === null || data[key] === '' || data[key] === undefined || data[key].length === 0) {
                key === 'selectedDriver' ? key = 'Conductor' : key === 'races' ? key = 'Clientes a repartir' : key = '';
                missingKeys += key + ', ';
            }
        }

        return missingKeys !== '' ? missingKeys.slice(0, -2) : true; // remove last ', '
    }

    validateRouteData() {
        const errors: string[] = [];
        const visitsDetail = this.state.data.visitsDetail || [];

        // Validar que haya visitas
        if (!visitsDetail || visitsDetail.length === 0) {
            errors.push("No hay visitas para calcular la ruta");
            return { valid: false, errors };
        }

        // Validar origen
        if (!this.state.data.origin || (this.state.data.origin.lat === 0 && this.state.data.origin.lng === 0)) {
            errors.push("Origen no válido o no establecido");
        }

        // Validar cada visita
        visitsDetail.forEach((visit: any, index: number) => {
            if (!visit.location || !visit.location.lat || !visit.location.lng) {
                errors.push(`Visita ${index + 1}: coordenadas faltantes`);
            }

            if (visit.location && (visit.location.lat === 0 && visit.location.lng === 0)) {
                errors.push(`Visita ${index + 1}: coordenadas inválidas (0,0)`);
            }

            if (!visit.destiny || !visit.destiny.street1 || visit.destiny.street1.trim() === '') {
                errors.push(`Visita ${index + 1}: dirección faltante`);
            }
        });

        // Validar límite de waypoints de Google (máximo 25 incluyendo origen y destino)
        const totalWaypoints = visitsDetail.length + 2; // +2 por origen y destino
        if (totalWaypoints > 25) {
            errors.push(`Demasiadas paradas (${totalWaypoints}). Google permite máximo 25 waypoints`);
        }

        return {
            valid: errors.length === 0,
            errors
        };
    }

    handleSubmit = async () => {
        const visitsDetail = this.state.data.visitsDetail;
        const dataToValidate: any = {
            visitDateTimeSchedule: format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
            selectedDriver: this.state.data.selectedDriver
                ? this.state.data.selectedDriver.id
                : undefined,
            limit: this.state.limit,
            races: this.state.data.visitsDetail
                ? this.state.data.visitsDetail.map((item: any, index: number) => {
                    return {
                        branchOrigin: this.state.data.selectedBranch,
                        clientId: item.client.id,
                        visitDateTime: format(item.visitDateTime, "YYYY-MM-DDTHH:mm:ssZ"),
                        location: {
                            lat: item.location.lat,
                            lng: item.location.lng,
                        },
                        obs: item.observation ? item.observation : '',
                        order: index + 1,
                        street1: item.street1,
                        type: item.type ? item.type : 'REMISION',
                        amount: item.amount && item.amount !== 0 ? item.amount : this.props.config.races.pricePerKm,
                        driver: item.driver,
                        clientName: item.clientName,
                        clientDocument: item.clientDocument,
                        origin: item.origin,
                        destiny: item.destiny,
                        dueDate: item.dueDate,
                        tipoComprobante: item.tipoComprobante ? item.tipoComprobante : 'FAC',
                        nroComprobante: item.nroComprobante ? item.nroComprobante : 0,
                        observation: item.observation ? item.observation : '',
                    };
                })
                : null,
        };

        const dataIsValid = this.validateData(dataToValidate);

        if (dataIsValid === true) {
            if (visitsDetail && visitsDetail.length > 0) {
                visitsDetail.shift();
                this.setState(prevState => ({
                    data: {
                        ...prevState.data,
                        visitsDetail: visitsDetail
                    }
                }));
            }

            const data: any = {
                visitDateTimeSchedule: format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                selectedDriver: this.state.data.selectedDriver
                    ? this.state.data.selectedDriver.id
                    : undefined,
                vehicleId: this.state.data.vehicleId,
                limit: this.state.limit,
                races: this.state.data.visitsDetail
                    ? this.state.data.visitsDetail.map((item: any, index: number) => {
                        return {
                            branchOrigin: this.state.data.selectedBranch,
                            clientId: item.client.id,
                            visitDateTime: format(item.visitDateTime, "YYYY-MM-DDTHH:mm:ssZ"),
                            location: {
                                lat: item.location.lat,
                                lng: item.location.lng,
                            },
                            obs: item.observation ? item.observation : '',
                            order: index + 1,
                            street1: item.street1,
                            type: item.type ? item.type : 'REMISION',
                            amount: item.amount && item.amount !== 0 ? item.amount : this.props.config.races.pricePerKm,
                            driver: item.driver,
                            clientName: item.clientName,
                            clientDocument: item.clientDocument,
                            origin: item.origin,
                            destiny: item.destiny,
                            dueDate: item.dueDate,
                            tipoComprobante: item.tipoComprobante ? item.tipoComprobante : 'FAC',
                            nroComprobante: item.nroComprobante ? item.nroComprobante : 0
                            , observation: item.observation ? item.observation : '',
                        };
                    })
                    : null,
            };
            // console.log('Data a enviar desde RouteSelector:', data);
            // return
            this.props.sendData(data);
        } else {
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning('Faltan datos por completar: ' + dataIsValid);
            } else {
                alert('Faltan datos por completar: ' + dataIsValid);
            }
        }
    }
    handleCancel() {
        this.setState({
            data: {
                ...this.state.data,
                selectedDriver: undefined,
                selectedVehicle: undefined,
                vehicleId: undefined,
                visitsDetail: [],
                fullData: undefined,
            }
        })

    }

    handleOrderChange = (event: any, data: any) => {
        let newVisitDetail: any = [];
        if (Number(event.target.value) === 1) { return }
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitDetail = this.state.data.visitsDetail;
            newVisitDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    const newValue = event.target.value;
                    const isValueUsed = newVisitDetail.some((otherItem: any) => otherItem.id !== data.id && otherItem.order === newValue);
                    const previousItem = newVisitDetail.find((otherItem: any) => otherItem.order === item.order - 1);
                    if (!isValueUsed && (!previousItem || newValue > previousItem.order) && newValue <= newVisitDetail.length && newValue !== 1) {
                        item.order = newValue;
                    }
                }
            });

            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitDetail,
                },
            });
        }
    };

    handleObservationsChange = (event: any, data: any) => {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.observation = event.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    };
    handleClickRemove(id: number) {
        if (this.state.data.visitsDetail) {
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: this.state.data.visitsDetail.filter(
                        (item: any) => item.id !== id
                    ),
                },
            }, () => {
                this.reorganizateOrder(true);
                this.calculateWaypoints();
            });
        }
    }
    reorganizateDrag(overwrite: boolean = false) {
        if (this.state.data.visitsDetail) {
            const visDetail = this.state.data.visitsDetail.sort((a: any, b: any) => {
                return a.order - 1 - (b.order - 1);
            }).map((item: any, index: number) => {
                console.log(item.amount, "item.amount")
                return {
                    ...item,
                    order: !overwrite ? item.order : index + 1,
                    amount: item.amount && item.amount !== 0 ? item.amount : 0
                };
            });

            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: visDetail
                },
            }, () => {
                this.setState({ confirmarOrdenFlag: false })
                this.calculateWaypoints(false);

            });
        }
    }
    reorganizateOrder(overwrite: boolean = false) {
        if (this.state.data.visitsDetail) {
            const visDetail = this.state.data.visitsDetail.sort((a: any, b: any) => {
                return a.order - 1 - (b.order - 1);
            }).map((item: any, index: number) => {
                return {
                    ...item,
                    order: !overwrite ? item.order : index + 1,
                    amount: item.amount && item.amount !== 0 ? item.amount : 0
                };
            });

            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: visDetail
                },
            }, () => {
                this.setState({ confirmarOrdenFlag: false })
                this.calculateWaypoints(false);

            });
        }
    }
    cleanOrder() {
        if (this.state.data.visitsDetail) {
            this.setState({
                confirmarOrdenFlag: true,
                data: {
                    ...this.state.data,
                    visitsDetail: this.state.data.visitsDetail.map((item: any, index: number) => {
                        return {
                            ...item,
                            order: item.order === 1 ? 1 : '',
                        };
                    }),
                    fullData: undefined,
                },
            }, () => {
                // this.calculateWaypoints();

            });
        }
    }
    reordenateOrder() {
        if (this.state.data.visitsDetail) {
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: this.state.data.visitsDetail.map((item: any, index: number) => {
                        return {
                            ...item,
                            order: '',
                        };
                    }),
                },
            }, () => {
                this.setState({
                    confirmarOrdenFlag: false,
                });
            });
        }
    }

    calculateWaypoints(optimized: boolean = false) {
        if (this.state.data.visitsDetail && this.state.data.visitsDetail.length >= 1) {
            const directionsService = new google.maps.DirectionsService();
            // const directionsRenderer = new google.maps.DirectionsRenderer();

            const origin = this.state.data.origin;
            const destiny = this.state.data.visitsDetail && this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1] ? this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1] : undefined;
            console.log("Calculating waypoints with origin:", origin,destiny.location);
            console.log("Visits detail:", this.state.data.visitsDetail ? this.state.data.visitsDetail.map((loc) => console.log("Waypoint:", loc.location)) : []);
            // const destiny = this.state.data.visitsDetail && this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1]
            //     && this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1].order !== 1 ? this.state.data.visitsDetail[this.state.data.visitsDetail.length - 1] : undefined;

            directionsService.route(
                {
                    origin: origin ? new google.maps.LatLng(origin.lat, origin.lng) : new google.maps.LatLng(0, 0),
                    destination: destiny ? new google.maps.LatLng(destiny.location.lat, destiny.location.lng) : new google.maps.LatLng(0, 0),
                    waypoints: this.state.data.visitsDetail ? this.state.data.visitsDetail.map((loc) => ({
                        location: new google.maps.LatLng(loc.location.lat, loc.location.lng),
                        stopover: true,
                    })) : [],
                    travelMode: google.maps.TravelMode.DRIVING,
                    optimizeWaypoints: optimized,
                },
                (result, status) => {
                    
                    if (status === google.maps.DirectionsStatus.OK) {
                        const waypointOrder = result.routes[0].waypoint_order;
                        const orderedRoutes = waypointOrder.map(index => result.routes[0].legs[index]);

                        result.routes[0].legs = orderedRoutes;

                        // Calcular la distancia total de la ruta
                        let totalDistance = 0;
                        for (const leg of result.routes[0].legs) {
                            totalDistance += leg.distance.value;
                        }
                        // Convertir la distancia a kilómetros
                        totalDistance = totalDistance / 1000;

                        const prePrecio = Number(this.state.setPrice) !== 0 ? this.state.setPrice : this.props.config.races.pricePerKm
                        const precio = totalDistance * prePrecio;

                        if (this.state.data.visitsDetail && waypointOrder && optimized) {
                            const orderedVisits: any = waypointOrder.map((index, idx) => {
                                if (this.state.data.visitsDetail) {
                                    return { ...this.state.data.visitsDetail[index], order: idx + 1 };
                                }
                                return {};
                            });
                            this.setState({
                                data: {
                                    ...this.state.data,
                                    visitsDetail: orderedVisits,
                                },
                            });
                        }
                        this.setState({
                            // line: result.routes[0].overview_polyline,
                            data: {
                                ...this.state.data,
                                distance: totalDistance,
                                price: Number(precio),
                                fullData: result,
                            },
                        });
                    } else {
                        // Manejo detallado de errores de Google Directions API
                        const errorDetails = {
                            status: status,
                            result: result,
                            waypointsCount: this.state.data.visitsDetail ? this.state.data.visitsDetail.length : 0,
                            origin: origin,
                            destination: destiny ? destiny.location : null,
                            visitsDetail: this.state.data.visitsDetail
                        };

                        console.error("Error fetching directions:", errorDetails);

                        // Determinar mensaje de error específico según el status
                        let errorMessage = "Error al calcular la ruta";
                        let errorDescription = "";

                        switch (status) {
                            case google.maps.DirectionsStatus.INVALID_REQUEST:
                                errorMessage = "Solicitud inválida";
                                errorDescription = "Los parámetros de la ruta no son válidos. Verifique las direcciones.";
                                break;
                            case google.maps.DirectionsStatus.MAX_WAYPOINTS_EXCEEDED:
                                errorMessage = "Demasiadas paradas";
                                errorDescription = "Google Maps permite máximo 25 waypoints (paradas). Reduzca el número de destinos.";
                                break;
                            case google.maps.DirectionsStatus.NOT_FOUND:
                                errorMessage = "Ruta no encontrada";
                                errorDescription = "No se pudo encontrar una ruta válida entre los puntos especificados.";
                                break;
                            case google.maps.DirectionsStatus.OVER_QUERY_LIMIT:
                                errorMessage = "Límite de consultas excedido";
                                errorDescription = "Se ha excedido el límite de consultas a Google Maps. Intente más tarde.";
                                break;
                            case google.maps.DirectionsStatus.REQUEST_DENIED:
                                errorMessage = "Solicitud denegada";
                                errorDescription = "La solicitud fue denegada. Verifique la clave API de Google Maps.";
                                break;
                            case google.maps.DirectionsStatus.UNKNOWN_ERROR:
                                errorMessage = "Error desconocido";
                                errorDescription = "Ocurrió un error desconocido. Intente nuevamente.";
                                break;
                            case google.maps.DirectionsStatus.ZERO_RESULTS:
                                errorMessage = "Sin resultados";
                                errorDescription = "No se encontraron rutas entre los puntos especificados.";
                                break;
                            default:
                                errorDescription = `Error de Google Maps: ${status}`;
                        }

                        // Mostrar notificación al usuario
                        // if (this.props.notification && this.props.notification.notification) {
                        //     this.props.notification.notification.addError(
                        //         errorMessage,
                        //         errorDescription
                        //     );
                        // } else {
                        //     alert(`${errorMessage}: ${errorDescription}`);
                        // }
                        console.warn(`${errorMessage}: ${errorDescription}`);
                        // Limpiar datos de ruta en caso de error
                        this.setState({
                            data: {
                                ...this.state.data,
                                fullData: undefined,
                                distance: 0,
                                price: 0,
                            },
                        });
                    }
                }
            );
        } else {
            console.error("No hay visitas para calcular ruta");
            this.setState({
                data: {
                    ...this.state.data,
                    fullData: undefined,
                },
            });
        }
    }

    setNroComprobante(e: React.ChangeEvent<HTMLInputElement>, data: any) {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.nroComprobante = e.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    }
    setPrice(e: React.ChangeEvent<HTMLInputElement>, data: any) {
        let newVisitsDetail = [];
        if (this.state.data && this.state.data.visitsDetail) {
            newVisitsDetail = this.state.data.visitsDetail;
            newVisitsDetail.forEach((item: any) => {
                if (item.id === data.id) {
                    item.amount = e.target.value;
                }
            });
            this.setState({
                data: {
                    ...this.state.data,
                    visitsDetail: newVisitsDetail,
                },
            });
        }
    }
    onDragEnd(result: any) {
        if (!result.destination || result.destination.index === 0) {
            return; // Dropped outside the list
        }

        if (this.state.data.visitsDetail) {
            const items = Array.from(this.state.data.visitsDetail);
            const [reorderedItem] = items.splice(result.source.index, 1);
            items.splice(result.destination.index, 0, reorderedItem);

            // Update the 'order' field of each item with its new index
            items.forEach((item, index) => {
                item.order = index + 1;
            });

            this.setState({
                data: {
                    ...this.state.data,
                    items: items,
                },
            }, () => {
                this.reorganizateDrag(false);
            });
        }
    }
    handleFilterChange = (e: any) => {
        const filterLoc = e.target.value;
        this.setState({ filterLoc });

        if (filterLoc === '' || filterLoc.length > 2) {
            this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize, filterLoc, this.state.filterDir);
        }
    }
    handleFilterChangeDir = (e: any) => {
        const filterDir = e.target.value;
        this.setState({ filterDir });
        if (filterDir === '' || filterDir.length > 2) {
            this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize, this.state.filterLoc, filterDir);
        }
    };

    setSelection = (data: any) => {
        const loc = {
            client: data.owner,
            clientId: data.clientId,
            id: data.id,
            lat: data.route.destiny.lat,
            lng: data.route.destiny.lng,
            observation: data.route.destiny.observation,
            street1: data.route.destiny.street1,
            street2: data.route.destiny.street2,
        }
        console.log("setSelection loc:", loc);
        this.setState({ dateFromRace: "", dateToRace: "" });
        const client = this.state.data.clients && this.state.data.clients.length > 0
            ? this.state.data.clients.find((c: Client) => c.id === loc.clientId)
            : loc.client;
        if (this.state.data.visitsDetail) {
            const valorRepetido = this.state.data.visitsDetail.some(
                (item: any) => item.id === loc.lat + loc.lng
            );
            if (loc.street1 === "" || loc.street1 === undefined || loc.street1 === null) {
                alert("Reparto sin dirección establecida");
                return;
            }
            if (valorRepetido) {
                alert("El reparto ya fue seleccionado");
                return;
            }
        }

        // Lógica de cálculo de origen (con fallback)
        const currentVisits = this.state.data.visitsDetail ? [...this.state.data.visitsDetail] : [];
        console.log("Cantidad de visitas previas:", currentVisits.length);

        const baseOrigin = currentVisits.length > 0 ? {
            street1: currentVisits[currentVisits.length - 1].destiny.street1,
            lat: currentVisits[currentVisits.length - 1].destiny.lat,
            lng: currentVisits[currentVisits.length - 1].destiny.lng,
        } : {
            street1: this.state.data.originStreet ? this.state.data.originStreet : '',
            lat: this.state.data.origin ? this.state.data.origin.lat : 0,
            lng: this.state.data.origin ? this.state.data.origin.lng : 0,
        };

        const resolvedOrigin = {
            street1: baseOrigin.street1,
            lat: baseOrigin.lat,
            lng: baseOrigin.lng,
        };

        // Fallback: si el origen calculado es (0,0), usa data.route.origin
        const resolvedOriginLat = resolvedOrigin.lat !== undefined && resolvedOrigin.lat !== null
            ? Number(resolvedOrigin.lat)
            : 0;
        const resolvedOriginLng = resolvedOrigin.lng !== undefined && resolvedOrigin.lng !== null
            ? Number(resolvedOrigin.lng)
            : 0;

        if (resolvedOriginLat === 0 && resolvedOriginLng === 0 && data.route && data.route.origin) {
            resolvedOrigin.street1 = data.route.origin.street1 ? data.route.origin.street1 : '';
            resolvedOrigin.lat = data.route.origin.lat !== undefined && data.route.origin.lat !== null
                ? Number(data.route.origin.lat)
                : 0;
            resolvedOrigin.lng = data.route.origin.lng !== undefined && data.route.origin.lng !== null
                ? Number(data.route.origin.lng)
                : 0;
        } else {
            resolvedOrigin.lat = resolvedOriginLat;
            resolvedOrigin.lng = resolvedOriginLng;
        }

        // console.log("Origin para nueva visita:", baseOrigin, resolvedOrigin);

        // Si es la primera visita, actualizar el location del origen en visitsDetail[0]
        const updatedVisits = [...currentVisits];
        if (currentVisits.length > 0 && currentVisits[0]) {
            // Actualizar el location del primer elemento (origen) con las coordenadas resueltas
            updatedVisits[0] = {
                ...updatedVisits[0],
                location: new Dot(resolvedOrigin.lat, resolvedOrigin.lng)
            };
        }

        // Crear newVisitDetail usando loc directamente
        const newVisitDetail: any = {
            id: loc.lat + loc.lng,
            client: client,
            location: new Dot(loc.lat, loc.lng),
            visitDateTime: new Date().toISOString(),
            observations: data.observation ? data.observation : "",
            order: updatedVisits.length + 1,
            type: data.type ? data.type : this.state.data.selectedType ? this.state.data.selectedType : '',
            driver: this.state.data.selectedDriver ? this.state.data.selectedDriver.id : 0,
            clientName: this.state.data.selectedClientLocation ? this.state.data.selectedClientLocation.client.user.name : '',
            clientDocument: this.state.data.selectedClientLocation ? this.state.data.selectedClientLocation.client.document : '',
            origin: resolvedOrigin,
            destiny: {
                street1: loc.street1,
                lat: loc.lat,
                lng: loc.lng,
            },
            dueDate: new Date().getTime() + 1000 * 60 * 60 * 24,
            tipoComprobante: data.tipoComprobante ? data.tipoComprobante : 'FAC',
            nroComprobante: data.nroComprobante ? data.nroComprobante : 0,
            amount: data.route.price ? data.route.price : 0,
        };

        // UN SOLO setState: setea destiny temporalmente para el mapa, actualiza origin y visitsDetail
        this.setState(
            (prevState) => ({
                data: {
                    ...prevState.data,
                    selectedLoc: loc,
                    selectedClient: client,
                    destinyStreet: loc.street1, // Para el mapa
                    destiny: new Dot(loc.lat, loc.lng), // Para el mapa
                    origin: new Dot(resolvedOrigin.lat, resolvedOrigin.lng),
                    visitsDetail: [
                        ...updatedVisits,
                        newVisitDetail,
                    ],
                },
                center: new Dot(loc.lat, loc.lng),
            }),
            () => {
                // Limpieza después de actualizar
                this.setState({
                    data: {
                        ...this.state.data,
                        destiny: undefined,
                        destinyStreet: "",
                        selectedClient: undefined,
                    },
                });
                console.log("Visitas después de agregar nueva:", this.state.data.visitsDetail);
                this.fireNewDataEvent(true);
                this.calculateWaypoints();
            }
        );
    };


    render() {
        const defaultLocation = {
            id: 0, lat: 0, lng: 0, street1: '',
            client: {
                user: { name: '', email: '' },
                phone: ''

            }
        };
        let clientLocations: LocationData[] = [defaultLocation];

        if (this.state.data.clientLocations && this.state.data.clientLocations.length > 0) {
            clientLocations = this.state.data.clientLocations;
            const newLocation = {
                id: 0, lat: 0, lng: 0, street1: '',
                client: {
                    user: {
                        name: clientLocations[0].client.user.name,
                        email: clientLocations[0].client.user.email
                    },
                    phone: clientLocations[0].client.phone
                }
            };
            clientLocations.push(newLocation);

        }
        const setearLocation = this.state.locations ? this.state.locations.map((location, index) => {
            if (location.client === null) {
                location.client = {
                    user: {
                        name: 'Usuario sin nombre: ' + location.clientId
                    }
                };
            }
            return location;
        }) : null;

        const filteredLocations = setearLocation ? setearLocation
            // .filter((loc: any) => loc.client && loc.client.user && loc.client.user.name &&
            //     (loc.client.user.name.toLocaleUpperCase().includes(this.state.filterLoc.toLocaleUpperCase()))
            //     ||
            //     (loc.street1 && loc.street1.toLocaleUpperCase().includes(this.state.filterLoc.toLocaleUpperCase())))
            .map((loc: any, index: number) => (
                <TableRow key={index}>
                    <TableCell>
                        {
                            loc.client && loc.client.user && loc.client.user.name ? loc.client.user.name :
                                (this.state.data.clients && loc.clientId) ? this.state.data.clients.find(c => c.id === loc.clientId)!.user.name : "Usuario sin nombre: " + loc.clientId
                        }
                    </TableCell>
                    <TableCell>{loc.street1 + ", " + loc.street2}</TableCell>
                    <TableCell>{loc.observation ? loc.observation : 'Sin observaciones'}</TableCell>
                    <TableCell>
                        {/* <Button color="primary" onClick={() => this.selectLocation(loc)}> */}
                        <Button color="primary" onClick={() => this.onChangeClientLocationSelect(loc)}>
                            <CheckIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            )) : (
            <button onClick={() => console.log()}>
                No se encontraron datos, haz clic aquí para ir a otro sitio
            </button>
        );
        const visitadoresTable = this.state.data && this.state.data.drivers && this.state.data.drivers
            .filter(driver => driver.user.name && driver.user.name.toLocaleUpperCase().includes(this.state.filter.toLocaleUpperCase()))
            .map(driver => (
                <TableRow key={driver.id}>
                    <TableCell>{driver.user.name}</TableCell>
                    <TableCell>
                        <Button color="primary" onClick={() => this.selectDriver(driver)}>
                            <CheckIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            ))
        const vehiclesTable = this.state.data.selectedDriver && this.state.data.selectedDriver.vehicles
            ? this.state.data.selectedDriver.vehicles
                .filter((vehicle: any) => `${vehicle.brand} ${vehicle.model} (${vehicle.type})`.toLocaleUpperCase().includes(this.state.filterVehicle.toLocaleUpperCase()))
                .map((vehicle: any) => (
                    <TableRow key={vehicle.id}>
                        <TableCell>{vehicle.brand} {vehicle.model} Pago fijo: {vehicle.fixedPayment ? vehicle.fixedPayment : 'No definido'} Pago por Km: {vehicle.paymentPerKm ? vehicle.paymentPerKm : 'No definido'}</TableCell>
                        <TableCell>
                            <Button color="primary" onClick={() => this.selectVehicle(vehicle)}>
                                <CheckIcon />
                            </Button>
                        </TableCell>
                    </TableRow>
                ))
            : null;
        return (<div>
            <Grid container direction="row">
                <Paper style={{ marginRight: '15px', padding: '15px', marginBottom: '15px' }} >
                    {/* <h5 style={{ marginBottom: '15px' }}>Datos de Visita</h5> */}
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                        <StepIndicator step={1} />
                        <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Visitador</Typography>
                    </div>
                    <Button color="primary" style={{ border: '1px solid #000' }}
                        onClick={() => this.setState({ isDialogOpen: true })}>
                        Seleccionar visitador <SearchIcon />
                    </Button>
                    {this.state.data.selectedDriver && (
                        < TextField
                            id="driverId"
                            label="Usuario seleccionado"
                            value={this.state.data.selectedDriver ? this.state.data.selectedDriver.user.name : ''}
                            style={{
                                width: '90%',
                            }}
                            margin="normal"
                            InputProps={{
                                disabled: true,
                            }}
                            error={!this.state.data.selectedDriver}
                        />
                    )}

                    {this.state.data.selectedDriver && (
                        <div style={{ marginBottom: '2px' }}>
                            <Button color="primary" style={{ border: '1px solid #000', marginTop: '10px' }}
                                onClick={() => this.setState({ isDialogOpenVehicle: true })}>
                                Seleccionar vehículo <SearchIcon />
                            </Button>
                            {this.state.data.selectedVehicle && (
                                <TextField
                                    id="vehicleId"
                                    label="Vehículo seleccionado"
                                    value={this.state.data.selectedVehicle ? `${this.state.data.selectedVehicle.brand} ${this.state.data.selectedVehicle.model} (${this.state.data.selectedVehicle.type})` : ''}
                                    style={{
                                        width: '90%',
                                    }}
                                    margin="normal"
                                    InputProps={{
                                        disabled: true,
                                    }}
                                    error={!this.state.data.selectedVehicle}
                                />
                            )}
                        </div>
                    )}
                    <Dialog
                        open={this.state.isDialogOpen}
                        onClose={() => this.setState({ isDialogOpen: false })}
                    >
                        <DialogTitle>
                            <IconButton color="inherit" onClick={() => {
                                this.setState({ isDialogOpen: false });
                            }} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            Visitador disponible</DialogTitle>
                        <DialogContent>
                            {
                                this.state.data && this.state.data.drivers && this.state.data.drivers.length > 0 ? (
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <p>Nombre del visitador</p>
                                                    <input
                                                        autoFocus={true}
                                                        autoComplete="new-password"
                                                        name="search"
                                                        value={this.state.filter}
                                                        id="search"
                                                        placeholder="Filtrar"
                                                        onChange={(e) => this.setState({ filter: e.target.value })}
                                                    />
                                                </TableCell>
                                                <TableCell>Seleccionar</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                visitadoresTable && visitadoresTable.length > 0 ? visitadoresTable : (
                                                    <Link to={{
                                                        pathname: `/driver`,
                                                    }}>
                                                        <Button
                                                            color="primary"
                                                        >{'Sin conductores....Crear conductor/usuario'}<AddLocation /></Button>
                                                    </Link>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                ) : (
                                    <Link to={{
                                        pathname: `/driver`,
                                    }}>
                                        <Button
                                            color="primary"
                                        >{'Sin conductores....Crear conductor/usuario'}<AddLocation /></Button>
                                    </Link>
                                )
                            }
                        </DialogContent>
                    </Dialog>

                    <Dialog
                        open={this.state.isDialogOpenVehicle}
                        onClose={() => this.setState({ isDialogOpenVehicle: false, filterVehicle: '' })}
                    >
                        <DialogTitle>
                            <IconButton color="inherit" onClick={() => {
                                this.setState({ isDialogOpenVehicle: false, filterVehicle: '' });
                            }} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            Vehículos disponibles</DialogTitle>
                        <DialogContent>
                            {
                                vehiclesTable && vehiclesTable.length > 0 ? (
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <p>Vehículo</p>
                                                    <input
                                                        autoFocus={true}
                                                        autoComplete="new-password"
                                                        name="searchVehicle"
                                                        value={this.state.filterVehicle}
                                                        id="searchVehicle"
                                                        placeholder="Filtrar"
                                                        onChange={(e) => this.setState({ filterVehicle: e.target.value })}
                                                    />
                                                </TableCell>
                                                <TableCell>Seleccionar</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {vehiclesTable}
                                        </TableBody>
                                    </Table>
                                ) : (
                                    <p>No hay vehículos disponibles para este conductor.</p>
                                )
                            }
                        </DialogContent>
                    </Dialog>

                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px', marginBottom: '10px' }}>
                            <StepIndicator step={2} />
                            <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Origen</Typography>
                        </div>

                        <Typography variant="caption">
                            Busca en las casillas de abajo y se actualizará el mapa
                        </Typography>
                        {
                            this.state.data.branchList && this.state.data.branchList.length > 0 &&
                            <BranchSelector
                                value={0}
                                branchList={this.state.data.branchList}
                                onChange={this.onChangeBranchSelector}
                            />

                        }
                        <StandaloneSearchBox
                            ref={this.onOriginMounted}
                            bounds={this.state.data.searchBounds}
                            onPlacesChanged={this.onPlaceSelected('origin')}>
                            <TextField
                                id="origin"
                                label="Otra dirección de salida"
                                value={this.state.data.originStreet}
                                style={{
                                    width: '90%'
                                }}
                                margin="normal"
                                onChange={(e) => this.setState({
                                    data: {
                                        ...this.state.data,
                                        originStreet: e.target.value
                                    }
                                })}
                                placeholder="Desde donde?"
                            />
                        </StandaloneSearchBox>
                    </div>
                    <div>
                        <h6 style={{ display: 'flex', alignItems: 'flex-start' }}><label>Distancia límite para la entrega(opcional)</label></h6>
                        {
                            <TextField
                                label="Distancia en metros"
                                type="number"
                                inputProps={{ step: "1" }}
                                onChange={(e) => this.setState({ limit: parseInt(e.target.value, 10) })}
                                value={this.state.limit}
                                style={{
                                    width: '90%'
                                }}
                                margin="normal"
                            />
                        }
                    </div>

                </Paper>

                {/* <Grid item md={2}>
                    <h6 style={{ display: 'flex', alignItems: 'flex-start' }}><Filter2 /><label>Tipo de reparto</label></h6>
                    <InputLabel id="demo-simple-select-standard-label">Seleccionar</InputLabel>
                    <Select value={this.state.selectedValue} onChange={this.handleSelectChange}>
                        {options.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid> */}
                {/* <Grid item md={3} style={{ marginRight: '15px' }}>

                </Grid> */}
                <br />
                <Grid item md={6} style={{ marginRight: '15px' }}>
                    <Grid container direction="row">
                        <Paper style={{ marginRight: '15px', padding: '15px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                <StepIndicator step={3} />
                                <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Seleccione remisiones o nuevo destino</Typography>
                            </div>
                            <Typography style={{ fontWeight: 'bold', fontSize: '16px' }}>Remisiones pendientes</Typography>
                            {
                                <Button
                                    color="primary" style={{ border: '1px solid #000', marginBottom: '10px' }} onClick={() => this.setState({ isDialogOpenReparto: true })}>
                                    Seleccionar Reparto <SearchIcon />
                                </Button>

                            }
                            <h6 style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <label>
                                    <Typography style={{ fontWeight: 'bold', fontSize: '16px' }}>Nuevo Destino</Typography>
                                    {
                                        this.props.data && this.props.data.clients &&
                                        <Link to={{
                                            pathname: `/addlocation`,
                                            state: this.props.data.clients
                                        }}>{'Nueva dirección (opc.)'}<AddLocation /></Link>
                                    }
                                </label>
                            </h6>
                            {
                                <Button color="primary" style={{ border: '1px solid #000' }} onClick={() => this.setState({ isDialogOpenLoc: true })}>
                                    Seleccionar <SearchIcon />
                                </Button>

                            }

                            {/* <h6 style={{ display: 'flex', alignItems: 'flex-start', marginTop: '5px' }}>
                                <label>
                                    <label style={{ marginRight: '3px', marginTop: '5px' }}>Hojas de Ruta</label>

                                </label>
                            </h6>
                            {
                                <Button color="primary" style={{ border: '1px solid #000' }} onClick={() => this.setState({ isDialogHojaOpen: true })}>
                                    Seleccionar Hojas de ruta <SearchIcon />
                                </Button>

                            } */}

                        </Paper>

                        {/* <Grid item md={6}>
                            <h6 style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <label style={{ marginRight: '3px' }}>Observaciones</label>
                            </h6>
                            {
                                <TextField
                                    id="observations"
                                    label="Ingrese alguna observación"
                                    value={this.state.data.observation ? this.state.data.observation : ''}
                                    style={{
                                        width: '90%'
                                    }}
                                    rows={5}
                                    multiline
                                    margin="normal"
                                    onChange={(e) => this.setState({
                                        data: {
                                            ...this.state.data,
                                            observation: e.target.value
                                        }
                                    })}
                                />

                            }
                        </Grid> */}
                    </Grid>

                    <Dialog
                        open={this.state.isDialogOpenLoc}
                        onClose={() => this.setState({ isDialogOpenLoc: false, filterLoc: '' }, () => this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize, this.state.filterLoc, this.state.filterDir))}
                        maxWidth={false}
                    >
                        <DialogTitle>
                            <IconButton color="inherit" onClick={() =>
                                this.setState(
                                    {
                                        isDialogOpenLoc: false,
                                        filterLoc: '',
                                        filterDir: '',
                                        pageNum: 0,
                                        pageSize: 3
                                    },
                                    () => this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize, this.state.filterLoc, this.state.filterDir))}
                                aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            Ubicaciones/sucursales de clientes
                        </DialogTitle>
                        <DialogContent style={{ maxWidth: 'none' }}>
                            {
                                this.state.locations ? (
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <p style={{ margin: 0 }}>Clientes</p>
                                                    <TextField
                                                        autoComplete="new-password"
                                                        name="search"
                                                        value={this.state.filterLoc}
                                                        id="searchName"
                                                        placeholder="Filtrar, min 3 caracteres"
                                                        onChange={this.handleFilterChange}
                                                        style={{ padding: 0 }}
                                                        autoFocus={true}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <p style={{ margin: 0 }}>Direccion</p>
                                                    <TextField
                                                        name="searchDir"
                                                        value={this.state.filterDir}
                                                        id="searchNameDir"
                                                        placeholder="Filtrar, min 3 caracteres"
                                                        onChange={this.handleFilterChangeDir}
                                                        style={{ padding: 0 }}
                                                    />
                                                </TableCell>
                                                <TableCell>Obs</TableCell>
                                                <TableCell>Seleccionar</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <>
                                                {Array.isArray(filteredLocations) && filteredLocations.length > 0 ? (
                                                    filteredLocations
                                                ) : (
                                                    this.props.data && this.props.data.clients &&
                                                    <Link to={{
                                                        pathname: `/addlocation`,
                                                        state: this.props.data.clients
                                                    }}>
                                                        <Button
                                                            style={{ border: '1px solid #000' }}
                                                            color="primary"
                                                        >{'No se encontró la dirección, crear una nueva'}<AddLocation /></Button>
                                                    </Link>
                                                )}
                                            </>
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    count={this.state.data ? this.state.totalItems : 0}
                                                    page={this.state.pageNum}
                                                    rowsPerPage={this.state.pageSize}

                                                    onChangePage={(event, newPage) => this.setState({ pageNum: newPage }, () => this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize, this.state.filterLoc, this.state.filterDir))}
                                                    onChangeRowsPerPage={
                                                        (event) =>
                                                            this.setState({ pageSize: +event.target.value, pageNum: 0 },
                                                                () => this.obtenerUbicaciones(this.state.pageNum, this.state.pageSize, this.state.filterLoc, this.state.filterDir))}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                ) : (
                                    <CircularProgress />
                                )
                            }
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.state.isDialogOpenReparto}
                        onClose={() => this.setState({ isDialogOpenReparto: false })}
                        maxWidth={false}
                    >
                        <DialogTitle>
                            <IconButton color="inherit" onClick={() => this.setState({ dateFromRace: "", dateToRace: "", isDialogOpenReparto: false })} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            Remisiones</DialogTitle>
                        <DialogContent style={{ maxWidth: 'none' }}>
                            {this.state.dataRace ? (
                                <TableRacesComponent
                                    data={this.state.dataRace}
                                    dataDrivers={this.state.data.drivers || []}
                                    dataBranches={[]}
                                    dataBranchesDestiny={[]}
                                    dateFrom={this.state.dateFromRace}
                                    dateTo={this.state.dateToRace}
                                    filter={this.state.filter}
                                    handleClearFilters={this.cleanFiltersRaces}
                                    onFilterChange={this.setFilter}
                                    onPageNumChange={this.setPageNum}
                                    onPageSizeChange={this.setPageSize}
                                    onDateFromChange={this.setDateFromChange}
                                    onDateToChange={this.setDateToChange}
                                    pageNum={this.state.pageNumRace}
                                    pageSize={this.state.pageSizeRace}
                                    racetoAdd={true}
                                    setDialog={this.setDialogRace}
                                    setDialogBranch={this.setDialogBranch}
                                    setDialogDriver={this.setDialogDriver}
                                    setDialogClient={this.setDialogClient}
                                    setDialogChangeState={this.setDialogChangeState}
                                    setSelection={this.setSelection}
                                    totalItems={this.state.totalItemsRace}
                                    onHandleTypeChange={this.handleTypeChange}
                                    selectedType={this.state.type}
                                    onHandleDriverChange={this.handleDriverChange}
                                    driverId={this.state.driverId}
                                    branchId={this.state.branchId}
                                    branchDestinyId={this.state.branchDestinyId}
                                    selectedState={this.state.selectedState}
                                    generalSearch=""
                                    onHandleStateChange={this.handleStateChange}
                                    onHandleBranchChange={this.handleBranchChange}
                                    onHandleBranchDestinyChange={this.handleBranchDestinyChange}
                                    handleGeneralSearch={this.handleGeneralSearch}
                                    filtrosOn={false}
                                />
                            ) : (
                                <CircularProgress />
                            )}
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.state.isDialogHojaOpen}
                        onClose={() => this.setState({ isDialogHojaOpen: false })}
                        maxWidth={false}
                    >
                        <DialogTitle>
                            <IconButton color="inherit" onClick={() => this.setState({ dateFromRace: "", dateToRace: "", isDialogHojaOpen: false })} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            Hojas de Ruta</DialogTitle>
                        <DialogContent style={{ maxWidth: 'none' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            Cabecera
                                        </TableCell>
                                        <TableCell>Seleccionar</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            Valores
                                        </TableCell>
                                        <TableCell>
                                            Seleccionar
                                        </TableCell>

                                    </TableRow>
                                </TableBody>
                            </Table>
                        </DialogContent>
                    </Dialog>
                </Grid>
                <br />
                <hr />

                <Paper style={{ marginBottom: '15px', width: '100%' }}>
                    {/* <EnhancedMap
                        center={this.state.center}
                        zoom={this.props.config.maps.startingLocation.zoom}

                        destiny={this.state.data.destiny}
                        origin={this.state.data.origin}
                        directions={this.state.data.fullData}

                        handleDragEnd={this.handleDragEnd}
                        handleOnClick={this.handleOnClick}
                    >
                    </EnhancedMap> */}
                    <EnhancedMap
                        center={this.state.center}
                        zoom={this.props.config.maps.startingLocation.zoom}
                        destiny={
                            this.state.data.visitsDetail &&
                                this.state.data.visitsDetail.length > 0
                                ? this.state.data.visitsDetail
                                : this.state.data.destiny
                        }
                        directions={this.state.data.fullData}
                        handleDragEnd={this.handleDragEnd}
                        handleOnClick={this.handleOnClick}
                    ></EnhancedMap>

                </Paper>

                <Grid item md={12}>
                    {this.getRouteDescription()}
                </Grid>
                <Paper style={{ marginBottom: '15px', width: '100%', padding: '15px' }}>
                    <hr />
                    <Grid container direction="row" style={{ display: 'flex', alignItems: 'center' }}>
                        {/* <pre>{JSON.stringify(this.state.data.visitsDetail, null, 2)}</pre> */}
                        <h6>Clientes a Repartir</h6>
                        <Button title="" color="primary" onClick={this.cleanOrder}><ClearAll /> Reasignar orden manualmente</Button>
                        {this.state.confirmarOrdenFlag &&
                            <Button title="" color="primary" onClick={() => this.reorganizateOrder()}><CheckCircleIcon /> Confirmar Orden</Button>
                        }

                        <Button color="primary" onClick={() => this.calculateWaypoints(true)}><LocationSeraching /> Optimizar ruta</Button>
                    </Grid>

                    <div style={{ width: '100%' }}>
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Cliente</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Fecha</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Tipo de reparto</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Tipo de documento</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>N° documento opcional</label></div>
                                <div style={{ width: '11%' }}><label style={{ fontSize: '13px' }}>Fijar precio</label></div>
                                <div style={{ width: '17%' }}><label style={{ fontSize: '13px' }}>Obs</label></div>
                                <div style={{ width: '17%' }}><label style={{ fontSize: '13px' }}>Hoja de ruta</label></div>
                                <div style={{ width: '6%' }}><label style={{ fontSize: '13px' }}>Orden</label></div>
                                <div style={{ width: '5%' }}><label style={{ fontSize: '13px' }}>Acciones</label></div>
                            </div>
                        </div>
                        <div>
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            {this.state.data.visitsDetail ? (
                                                <>
                                                    {this.state.data.visitsDetail.map((cli: any, index: number) => (
                                                        <Draggable key={`${cli.id}-${index}`} draggableId={`${cli.id}-${index}`} index={index}>
                                                            {(prov: any) => (
                                                                <div
                                                                    ref={prov.innerRef}
                                                                    {...prov.draggableProps}
                                                                    {...prov.dragHandleProps}
                                                                >
                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', fontSize: '11px', border: '1px solid black', borderRadius: '5px' }}>
                                                                        <div style={{ width: '11%', marginLeft: '2px' }}>{cli.client.user.name}</div>
                                                                        <div style={{ width: '11%', marginLeft: '2px' }}>{cli.visitDateTime}</div>
                                                                        <div style={{ width: '11%', marginLeft: '2px' }}>
                                                                            {cli.order !== 1 &&
                                                                                <Select
                                                                                    style={{ fontSize: '11px' }}
                                                                                    value={cli.type ? cli.type : 'REMISION'} onChange={(event) => this.handleSelectChangeOnRow(event, cli)}>
                                                                                    {options.map((option) => (
                                                                                        <MenuItem key={option.value} value={option.value}>
                                                                                            {option.label}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            }
                                                                        </div>
                                                                        <div style={{ width: '11%', marginLeft: '2px', alignItems: 'center', display: 'flex', justifyContent: 'space-around' }}>{cli.order !== 1 &&
                                                                            <Select
                                                                                style={{ fontSize: '11px' }}
                                                                                value={cli.tipoComprobante ? cli.tipoComprobante : 'FAC'} onChange={(event) => this.handleSelectChangeComprobanteOnRow(event, cli)}>
                                                                                {tipoComprobante.map((option) => (
                                                                                    <MenuItem
                                                                                        key={option.value} value={option.value}>
                                                                                        {option.label}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                        }
                                                                        </div>
                                                                        <div style={{ width: '11%', marginLeft: '2px' }}>{cli.order !== 1 &&
                                                                            <TextField
                                                                                label="Nro documento (opcional)"
                                                                                type="number"
                                                                                onChange={(e) => this.setNroComprobante(e, cli)}
                                                                                value={cli.nroComprobante || ''}
                                                                                style={{
                                                                                    width: '90%'
                                                                                }}
                                                                                margin="normal"
                                                                                InputLabelProps={{
                                                                                    style: { fontSize: '11px' }
                                                                                }}
                                                                            />
                                                                        }</div>
                                                                        <div style={{ width: '11%', marginLeft: '2px' }}>{cli.order !== 1 &&
                                                                            <TextField
                                                                                label="Fijar precio (opcional)"
                                                                                type="number"
                                                                                inputProps={{ step: "100" }}
                                                                                onChange={(e) => this.setPrice(e, cli)}
                                                                                value={cli.amount || ''}
                                                                                style={{
                                                                                    width: '90%'
                                                                                }}
                                                                                margin="normal"
                                                                                InputLabelProps={{
                                                                                    style: { fontSize: '11px' }
                                                                                }}
                                                                            />
                                                                        }</div>
                                                                        <div style={{ width: '17%', marginLeft: '2px' }}> <TextField
                                                                            id="observations"
                                                                            placeholder="Observaciones"
                                                                            multiline
                                                                            rows={3}
                                                                            value={cli.observation ? cli.observation : ''}
                                                                            onChange={(event) =>
                                                                                this.handleObservationsChange(event, cli)
                                                                            }
                                                                            style={{
                                                                                width: "90%",
                                                                            }}
                                                                            InputProps={{
                                                                                style: {
                                                                                    fontSize: '11px',
                                                                                }
                                                                            }}
                                                                            margin="normal"
                                                                        /></div>
                                                                        <div style={{ width: '17%', marginLeft: '2px' }}>
                                                                            <a href="#">Enlace a hoja de ruta</a>
                                                                        </div>
                                                                        <div style={{ width: '6%', marginLeft: '2px' }}>{<TextField
                                                                            id="order"
                                                                            placeholder="Orden"
                                                                            type="text"
                                                                            value={cli.order}
                                                                            onChange={(event) => this.handleOrderChange(event, cli)}
                                                                            style={{
                                                                                width: "40%",
                                                                            }}
                                                                            InputProps={{
                                                                                style: {
                                                                                    fontSize: '11px',
                                                                                }
                                                                            }}
                                                                            margin="normal"
                                                                        />}</div>
                                                                        <div style={{ width: '5%', marginLeft: '2px' }}>{cli.order && cli.order > 1 &&
                                                                            <div>
                                                                                <IconButton
                                                                                    aria-label="Visitados"
                                                                                    title="Visitados"
                                                                                    onClick={() =>
                                                                                        cli.client && this.handleClickRemove(cli && cli.id ? cli.id : 0)
                                                                                    }
                                                                                >
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </div>}</div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </>
                                            ) : (
                                                <CircularProgress />
                                            )}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                    </div>
                    {/*<AsyncTable
                        columnDefinition={this.state.table.columnData}
                        title=""
                        showHeader={false}
                        data={this.state.data.visitsDetail || []}
                        defaultOrder={{
                            name: "name",
                            direction: "asc",
                        }}
                    />*/}
                    <br />
                </Paper>



            </Grid>
            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                <Paper style={{ marginLeft: '15px', padding: '15px' }}>
                    <Button onClick={this.handleCancel}>Cancelar</Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSubmit}
                    > Guardar </Button>
                </Paper>
            </div>

        </div>);
    }

}


export default compose<any, RouteSelectorProps>(withProps((props: RouteSelectorProps) => {
    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    }
}), withScriptjs)(RouteSelector);



// WEBPACK FOOTER //
// ./src/components/routeSelector.tsx